var ko = require('knockout');

// NOTE: At the bottom of this file, every component in koComponents is registered

var koComponents = [
  // Calculator
  {
    name: 'calculator',
    viewModel: require('./calculator/calculator.js'),
    template: require('./calculator/calculator.template')
  },
  {
    name: 'oppdateringskalkulator',
    viewModel: require('./calculator/oppdateringskalkulator/oppdateringskalkulator.js'),
    template: require('./calculator/oppdateringskalkulator/oppdateringskalkulator.template')
  },
  {
    name: 'manglerkurs',
    viewModel: require('./calculator/manglerkurs/manglerkurs.js'),
    template: require('./calculator/manglerkurs/manglerkurs.template')
  },
  {
    name: 'timestatus',
    viewModel: require('./calculator/timestatus/timestatus.js'),
    template: require('./calculator/timestatus/timestatus.template')
  },
  {
    name: 'calculator-bar',
    viewModel: require('./calculator/bar/calculator-bar.js'),
    template: require('./calculator/bar/calculator-bar.template')
  },
  {
    name: 'calculator-course',
    viewModel: require('./calculator/courses/calculator-course.js'),
    template: require('./calculator/courses/calculator-course.template')
  },
  {
    name: 'calculator-courses',
    viewModel: require('./calculator/courses/calculator-courses.js'),
    template: require('./calculator/courses/calculator-courses.template')
  },
  {
    name: 'calculator-extended-course',
    viewModel: require('./calculator/extended/extended-course.js'),
    template: require('./calculator/extended/extended-course.template')
  },
  {
    name: 'calculator-extended-leave',
    viewModel: require('./calculator/extended/extended-leave.js'),
    template: require('./calculator/extended/extended-leave.template')
  },
  {
    name: 'calculator-notifier',
    viewModel: require('./calculator/notifier/notifier.js'),
    template: require('./calculator/notifier/notifier.template')
  },
  {
    name: 'calculator-timeunit',
    viewModel: require('./calculator/timeunit/timeunit.js'),
    template: require('./calculator/timeunit/timeunit.template')
  },
  {
    name: 'calculator-timeunits',
    viewModel: require('./calculator/timeunits/timeunits.js'),
    template: require('./calculator/timeunits/timeunits.template')
  },
  {
    name: 'calculator-year',
    viewModel: require('./calculator/year/calculator-year.js'),
    template: require('./calculator/year/calculator-year.template')
  },
  {
    name: 'calculator-years',
    viewModel: require('./calculator/years/calculator-years.js'),
    template: require('./calculator/years/calculator-years.template')
  },

  // Registration
  {
    name: 'registration-pages',
    viewModel: require('./registration/pages/registration-pages.js'),
    template: require('./registration/pages/registration-pages.template')
  },
  {
    name: 'registration-personal-info',
    viewModel: require('./registration/page/registration-personal-info.js'),
    template: require('./registration/page/registration-personal-info.template')
  },
  {
    name: 'registration-info-member',
    viewModel: require('./registration/page/registration-info-member.js'),
    template: require('./registration/page/registration-info-member.template')
  },
  {
    name: 'registration-employer',
    viewModel: require('./registration/page/registration-employer.js'),
    template: require('./registration/page/registration-employer.template')
  },
  {
    name: 'registration-confirmation',
    viewModel: require('./registration/page/registration-confirmation.js'),
    template: require('./registration/page/registration-confirmation.template')
  },
  {
    name: 'registration-enroll',
    viewModel: require('./registration/page/registration-enroll.js'),
    template: require('./registration/page/registration-enroll.template')
  },
  {
    name: 'registration-agency',
    viewModel: require('./registration/page/registration-agency.js'),
    template: require('./registration/page/registration-agency.template')
  },
  {
    name: 'registration-insurance',
    viewModel: require('./registration/page/registration-insurance.js'),
    template: require('./registration/page/registration-insurance.template')
  },
  {
    name: 'registration-end',
    viewModel: require('./registration/page/registration-end.js'),
    template: require('./registration/page/registration-end.template')
  },

  // Misc
  {
    name: 'external-course',
    viewModel: require('./external-course/external-course.js'),
    template: require('./external-course/external-course.template')
  },
  {
    name: 'course-instructors',
    viewModel: require('./course-instructors/course-instructors.js'),
    template: require('./course-instructors/course-instructors.template')
  },
  {
    name: 'bureau-employee-list',
    viewModel: require('./bureau-employee-list/employee-list/employee-list.js'),
    template: require('./bureau-employee-list/employee-list/employee-list.template')
  },
  {
    name: 'bureau-employee-list-modal',
    viewModel: require('./bureau-employee-list/add-employee-modal/add-employee-modal.js'),
    template: require('./bureau-employee-list/add-employee-modal/add-employee-modal.template')
  },
  {
    name: 'bureau-insurances',
    viewModel: require('./bureau-insurances/bureau-insurances.js'),
    template: require('./bureau-insurances/bureau-insurances.template')
  },
  {
    name: 'calendar',
    viewModel: require('./calendar/calendar.js'),
    template: require('./calendar/calendar.template')
  },
  {
    name: 'find-accountants',
    viewModel: require('./find-accountants/find-accountants.js'),
    template: require('./find-accountants/find-accountants.template')
  },
  {
    name: 'pagination',
    viewModel: require('./pagination/pagination.js'),
    template: require('./pagination/pagination.template')
  },
  {
    name: 'add-participant-box',
    viewModel: require('./add-participant-box/add-participant-box.js'),
    template: require('./add-participant-box/add-participant-box.template')
  },
  {
    name: 'choose-agency',
    viewModel: require('./choose-agency/choose-agency.js'),
    template: require('./choose-agency/choose-agency.template')
  },
  {
    name: 'create-employee',
    viewModel: require('./create-employee/create-employee.js'),
    template: require('./create-employee/create-employee.template')
  },
  {
    name: 'article-block',
    viewModel: require('./article-block/article-block.js'),
    template: require('./article-block/article-block.template')
  },
  {
    name: 'article-block-full',
    viewModel: require('./article-block-full/article-block-full.js'),
    template: require('./article-block-full/article-block-full.template')
  },
  {
    name: 'product-block',
    viewModel: require('./blocks/product-block/product-block.js'),
    template: require('./blocks/product-block/product-block.template')
  },
  {
    name: 'course-block',
    viewModel: require('./course-block/course-block.js'),
    template: require('./course-block/course-block.template')
  },
  {
    name: 'marketing-teaser-tile',
    viewModel: require('./marketing-teaser-tile/marketing-teaser-tile.js'),
    template: require('./marketing-teaser-tile/marketing-teaser-tile.template')
  },
  {
    name: 'form-checkbox-list',
    viewModel: require('./form/form-checkbox-list/form-checkbox-list.js'),
    template: require('./form/form-checkbox-list/form-checkbox-list.template')
  },
  {
    name: 'form-multiselect',
    viewModel: require('./form/form-multiselect/form-multiselect.js'),
    template: require('./form/form-multiselect/form-multiselect.template')
  },
  {
    name: 'form-multiselect-simple',
    viewModel: require('./form/form-multiselect-simple/form-multiselect-simple.js'),
    template: require('./form/form-multiselect-simple/form-multiselect-simple.template')
  },
  {
    name: 'form-selected-list',
    viewModel: require('./form/form-selected-list/form-selected-list.js'),
    template: require('./form/form-selected-list/form-selected-list.template')
  },
  {
    name: 'admin-tool-user-management',
    viewModel: require('./admin-tool-user-management/admin-tool-user-management.js'),
    template: require('./admin-tool-user-management/admin-tool-user-management.template')
  },
  {
    name: 'file-list',
    viewModel: require('./file-list/file-list.js'),
    template: require('./file-list/file-list.template')
  },
  {
    name: 'message',
    viewModel: require('./message/message.js'),
    template: require('./message/message.template')
  },
  {
    name: 'my-courses-page',
    viewModel: require('./my-courses-page/my-courses-page.js'),
    template: require('./my-courses-page/my-courses-page.template')
  },
  {
    name: 'my-planned-courses',
    viewModel: require('./my-courses-page/my-planned-courses/my-planned-courses.js'),
    template: require('./my-courses-page/my-planned-courses/my-planned-courses.template')
  },
  {
    name: 'my-completed-courses',
    viewModel: require('./my-courses-page/my-completed-courses/my-completed-courses.js'),
    template: require('./my-courses-page/my-completed-courses/my-completed-courses.template')
  },
  {
    name: 'courses-list-item',
    viewModel: require('./my-courses-page/courses-list-item/courses-list-item.js'),
    template: require('./my-courses-page/courses-list-item/courses-list-item.template')
  },
  {
    name: 'course-registration-overview',
    viewModel: require('./course-registration-overview/course-registration-overview.js'),
    template: require('./course-registration-overview/course-registration-overview.template')
  },
  {
    name: 'course-overview-list',
    viewModel: require('./course-registration-overview/course-overview-list/course-overview-list.js'),
    template: require('./course-registration-overview/course-overview-list/course-overview-list.template')
  },
  {
    name: 'course-registration-participants',
    viewModel: require('./course-registration-participants/course-registration-participants.js'),
    template: require('./course-registration-participants/course-registration-participants.template')
  },
  {
    name: 'course-participants-list',
    viewModel: require('./course-registration-participants/course-participants-list/course-participants-list.js'),
    template: require('./course-registration-participants/course-participants-list/course-participants-list.template')
  },
  {
    name: 'participant-details-modal',
    viewModel: require('./course-registration-participants/participant-details-modal/participant-details-modal.js'),
    template: require('./course-registration-participants/participant-details-modal/participant-details-modal.template')
  },
  {
    name: 'course-registration-feedback-box',
    viewModel: require('./course-registration-participants/course-registration-feedback-box/course-registration-feedback-box.js'),
    template: require('./course-registration-participants/course-registration-feedback-box/course-registration-feedback-box.template')
  },
  {
    name: 'sequence-details-block',
    viewModel: require('./course-registration-participants/sequence-details-block/sequence-details-block.js'),
    template: require('./course-registration-participants/sequence-details-block/sequence-details-block.template')
  },
  {
    name: 'report-page',
    viewModel: require('./report-page/report-page.js'),
    template: require('./report-page/report-page.template')
  }
];

// Register all the knockout components:
koComponents.forEach(function(koComponent) {
  ko.components.register(koComponent.name, {
    viewModel: koComponent.viewModel,
    template: koComponent.template
  });
});
